import { createAsyncThunk } from '@reduxjs/toolkit';
// ===== MOCK DATA =====
const mockInstagramData = {
    profile: {
        id: 'growth_blocks_official',
        username: 'growth_blocks',
        name: 'Growth Blocks',
        biography: '🚀 Design System & Growth Tools\n📊 Analytics & Insights\n💼 Business Solutions',
        profilePictureUrl: 'https://via.placeholder.com/150',
        followersCount: 125000,
        followingCount: 1250,
        mediaCount: 890,
        isVerified: true,
        isBusinessAccount: true,
    },
    insights: [
        { metric: 'reach', value: 45780, period: 'month', title: 'Alcance', description: 'Pessoas alcançadas' },
        { metric: 'impressions', value: 78900, period: 'month', title: 'Impressões', description: 'Visualizações totais' },
        { metric: 'engagement', value: 4.2, period: 'month', title: 'Engajamento', description: 'Taxa de engajamento' },
        { metric: 'profile_views', value: 12500, period: 'month', title: 'Visualizações do Perfil', description: 'Visitas ao perfil' },
    ],
    posts: [
        {
            id: '1',
            caption: 'Novo componente de dashboard lançado! 🎉',
            mediaType: 'image',
            mediaUrl: 'https://via.placeholder.com/400',
            permalink: 'https://instagram.com/p/1',
            timestamp: '2025-01-15T10:00:00Z',
            likes: 1250,
            comments: 85,
            shares: 45,
            saves: 120,
            reach: 8900,
            impressions: 12500,
        },
        {
            id: '2',
            caption: 'Tutorial: Como usar analytics no Growth Blocks',
            mediaType: 'video',
            mediaUrl: 'https://via.placeholder.com/400',
            thumbnailUrl: 'https://via.placeholder.com/400',
            permalink: 'https://instagram.com/p/2',
            timestamp: '2025-01-14T15:30:00Z',
            likes: 890,
            comments: 120,
            shares: 65,
            saves: 95,
            reach: 6700,
            impressions: 9800,
        },
    ],
    stories: [
        {
            id: 's1',
            mediaType: 'image',
            mediaUrl: 'https://via.placeholder.com/300x500',
            timestamp: '2025-01-15T08:00:00Z',
            views: 5600,
            replies: 45,
            exits: 120,
        },
    ],
    audience: [
        { ageRange: '18-24', gender: 'male', percentage: 25, count: 31250 },
        { ageRange: '18-24', gender: 'female', percentage: 30, count: 37500 },
        { ageRange: '25-34', gender: 'male', percentage: 20, count: 25000 },
        { ageRange: '25-34', gender: 'female', percentage: 25, count: 31250 },
    ],
    topHashtags: [
        { tag: '#designsystem', posts: 45, reach: 12000, impressions: 18000 },
        { tag: '#dashboard', posts: 38, reach: 9500, impressions: 14500 },
        { tag: '#analytics', posts: 32, reach: 8200, impressions: 12800 },
    ],
    engagement: {
        rate: 4.2,
        totalLikes: 45600,
        totalComments: 3200,
        totalShares: 1800,
        avgLikesPerPost: 512,
        avgCommentsPerPost: 36,
    },
    growth: {
        followersGrowth: [
            { date: '2025-01-01', count: 120000 },
            { date: '2025-01-05', count: 121500 },
            { date: '2025-01-10', count: 123000 },
            { date: '2025-01-15', count: 125000 },
        ],
        engagementGrowth: [
            { date: '2025-01-01', rate: 3.8 },
            { date: '2025-01-05', rate: 4.0 },
            { date: '2025-01-10', rate: 4.1 },
            { date: '2025-01-15', rate: 4.2 },
        ],
        reachGrowth: [
            { date: '2025-01-01', reach: 38000 },
            { date: '2025-01-05', reach: 41000 },
            { date: '2025-01-10', reach: 43500 },
            { date: '2025-01-15', reach: 45780 },
        ],
    },
};
// ===== FETCH INSTAGRAM DATA THUNK =====
export const fetchInstagramDataThunk = createAsyncThunk('instagram/fetchData', async (filters, { rejectWithValue }) => {
    try {
        console.log('📸 Fetching Instagram data...', filters);
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 600));
        // For now, return mock data
        // TODO: Replace with actual Instagram API call when backend is ready
        console.log('✅ Instagram data fetched successfully (mock)');
        return mockInstagramData;
    }
    catch (error) {
        console.error('❌ Instagram fetch error:', error);
        const message = error instanceof Error ? error.message : 'Failed to fetch Instagram data';
        return rejectWithValue(message);
    }
});
// ===== REFRESH INSTAGRAM DATA THUNK =====
export const refreshInstagramDataThunk = createAsyncThunk('instagram/refreshData', async (_, { rejectWithValue }) => {
    try {
        console.log('🔄 Refreshing Instagram data...');
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 400));
        // Add some variation to mock data for refresh
        const refreshedData = {
            ...mockInstagramData,
            profile: {
                ...mockInstagramData.profile,
                followersCount: mockInstagramData.profile.followersCount + Math.floor(Math.random() * 100),
            },
            insights: mockInstagramData.insights.map(insight => ({
                ...insight,
                value: insight.metric === 'engagement'
                    ? insight.value + (Math.random() * 0.2 - 0.1) // Small variation for engagement rate
                    : insight.value + Math.floor(Math.random() * 200) - 100
            })),
            posts: mockInstagramData.posts.map(post => ({
                ...post,
                likes: post.likes + Math.floor(Math.random() * 50),
                comments: post.comments + Math.floor(Math.random() * 10),
            }))
        };
        console.log('✅ Instagram data refreshed successfully (mock)');
        return refreshedData;
    }
    catch (error) {
        console.error('❌ Instagram refresh error:', error);
        const message = error instanceof Error ? error.message : 'Failed to refresh Instagram data';
        return rejectWithValue(message);
    }
});
// ===== FETCH INSTAGRAM POSTS THUNK =====
export const fetchInstagramPostsThunk = createAsyncThunk('instagram/fetchPosts', async (limit = 10, { rejectWithValue }) => {
    try {
        console.log(`📸 Fetching ${limit} Instagram posts...`);
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 500));
        // Return limited posts from mock data
        const posts = mockInstagramData.posts.slice(0, limit);
        console.log('✅ Instagram posts fetched successfully (mock)');
        return posts;
    }
    catch (error) {
        console.error('❌ Instagram posts fetch error:', error);
        const message = error instanceof Error ? error.message : 'Failed to fetch Instagram posts';
        return rejectWithValue(message);
    }
});
// ===== EXPORT MOCK DATA FOR DIRECT USE =====
export { mockInstagramData };
